const events = require("./auditCompletionEvents.js");

const Survey = require("~/types/Survey.js");

const auditCompletionHandlers = {
    [events.Started.Name](prev, event) {
        const update = {
            SurveySubmissionStatus: {
                InProgress: true,
                Error: null
            }
        };

        return Object.assign({}, prev, update);
    },
    [events.Completed.Name](prev, event) {
        const update = {
            CurrentSurvey: Survey.ForReload(event),
            SurveySubmissionStatus: {
                InProgress: false,
                Error: null
            },
            SurveySearchResults: Object.assign({}, prev.SurveySearchResults, {
                Data: null
            })
        };

        return Object.assign({}, prev, update);
    },
    [events.SampleScore.Name](prev, event) { 
        const update = {
            CurrentSurvey: Survey.FromSampleScore(prev.CurrentSurvey, event.score, event.maxScore)
        };

        return Object.assign({}, prev, update); 
    }, 
    [events.Errored.Name](prev, event) {
        const update = {
            SurveySubmissionStatus: {
                InProgress: false,
                Error: event.Error
            }
        };

        return Object.assign({}, prev, update);
    },
    [events.ErrorCleared.Name](prev, event) {
        const update = {
            SurveySubmissionStatus: {
                Error: null
            }
        };

        return Object.assign({}, prev, update);
    }
};

module.exports = auditCompletionHandlers;


// WEBPACK FOOTER //
// ./src/events/auditCompletion/auditCompletionHandlers.js